import NoItems from '@/components/ui/NoItems.tsx';
import { useDetailsScreen } from '@/features/dashboard/bookingChanges/contexts/DetailsContext.ts';
import useClientBillView from '@/features/dashboard/bookingChanges/hooks/useClientBillView.ts';
import {
  ClientBillView,
  ClientBillViewSkeleton,
} from '@/features/dashboard/bookingChanges/components/bill';

/**
 * Zakładka „Informacje” ekranu osoby zapisującej — dane osobowe, kontaktowe
 * i adres. Bez kwot, bo zapisujący nie ma własnego rachunku.
 */
const ClientInfoTab = () => {
  const { bookingId, bookingCode, isEditing, editField, onOpenBooking } =
    useDetailsScreen();

  const { view, isLoading } = useClientBillView(bookingId);

  if (isLoading) {
    return <ClientBillViewSkeleton />;
  }

  if (!view) {
    return (
      <NoItems
        title="Brak danych zapisującego"
        description="Ten klient nie jest jeszcze osobą zapisującą w żadnej rezerwacji."
      />
    );
  }

  return (
    <ClientBillView
      data={view}
      isEditing={isEditing}
      onRowAction={editField.openRow}
      onOpenBooking={onOpenBooking}
      bookingCode={bookingCode}
    />
  );
};

export default ClientInfoTab;
